import React, { useState, useEffect, useMemo, useCallback } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import Select from "react-select"
import CountUp from 'react-countup';
import { FaRegFileAlt } from 'react-icons/fa';
import { FiPlusSquare } from "react-icons/fi";
import { Modal } from "react-responsive-modal";
import 'react-responsive-modal/styles.css';
import "../../assets/css/inventorymanagement.css"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaInfoCircle } from "react-icons/fa";
import "./datepicker.css"
const CurrentStockIndentation = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("slider-25");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [file, setFile] = useState(null)
  const [originalrowData, setoriginalrowData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [currentSkuCode, setCurrentSkuCode] = useState("")
  const [currentinvoiceDate, setCurrentInvoiceDate] = useState("")
  const [currentUploadedDate, setCurrentUploadedDate] = useState("")
  const [highlightedDates, setHighlightedDates] = useState([]);


  const [prevDate, setPrevDate] = useState("");

  const [storeId, setStoreId] = useState(null);
  const [prevStoreId, setPrevStoreId] = useState(null);
  const [storeOptions, setStoreOptions] = useState([]); // [{ value: "id1", label: "Store 1" }, ...]

  const [skuCode, setSkuCode] = useState(null);
  const [prevSkuCode, setPrevSkuCode] = useState(null);
  const [skuOptions, setSkuOptions] = useState([]);

  const today = new Date().toLocaleDateString("en-CA", {
    timeZone: "Asia/Kolkata",
  });

  const [currentDate, setCurrentDate] = useState(today);
  const [triggerNote, setTriggerNote] = useState("");
  const [triggerStatus, setTriggerStatus] = useState("");
  const [isTrigger, setIsTrigger] = useState(null);

 
 // Old CustomHeader component
//    const CustomHeader = (props) => {
//      const tooltip = props?.column?.getColDef()?.headerTooltip || "";
//      const [showMenu, setShowMenu] = useState(false);
//      const [showTooltip, setShowTooltip] = useState(false);
   
//      const onMenuClick = (event) => {
//        props.showColumnMenu(event.currentTarget);
//      };
   
//      return (
//        <div
//          style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
//          onMouseEnter={() => setShowMenu(true)}
//          onMouseLeave={() => setShowMenu(false)}
//        >
//          {/* Header Name */}
//          <span style={{ cursor: "default" }}>{props.displayName}</span>
   
//          {/* Info Icon with instant tooltip */}
//          <div
//            style={{ position: "relative", display: "inline-block" }}
//            onMouseEnter={() => setShowTooltip(true)}
//            onMouseLeave={() => setShowTooltip(false)}
//          >
//            <FaInfoCircle style={{ fontSize: 18, opacity: 0.7,  }} />
         
//          </div>
   
//          {/* Menu Button (☰) visible only on hover */}
//          {props.enableMenu && (
//            <span
//              onClick={onMenuClick}
//              style={{
//                marginLeft: "5px",
//                cursor: "pointer",
//                fontSize: 14,
//                opacity: showMenu ? 1 : 0,
//                transition: "opacity 0.2s ease",
//              }}
//            >
//              ☰
//            </span>
//          )}
//        </div>
//      );
//    };

    // New CustomHeader component

const getHighlightedDates = async () => {  
  try {
    const response = await redirectURL.post("indentation/getDSCurrentStockdates", {});
    if (response.status === 200 && response.data.dates) {
      const dates = response.data.dates.map(dateStr => {
        try {
          return new Date(dateStr);
        } catch (e) {
          return null;
        }
      }).filter(date => date !== null);
      setHighlightedDates(dates);
    }
  } catch (error) {
    console.error("Failed to fetch highlighted dates:", error);
  }
}
    const CustomHeader = (props) => {
        const tooltip = props?.column?.getColDef()?.headerTooltip || "";
        const [showMenu, setShowMenu] = useState(false);
        const [showTooltip, setShowTooltip] = useState(false);

        const onMenuClick = (event) => {
            props.showColumnMenu(event.currentTarget);
        };

        // Handle sort icon click
        const onSortRequested = (order, event) => {
            props.setSort(order, event?.shiftKey);
        };

        // Get current sort state
        const getSort = () => {
            return props.column.getSort();
        };

        // Check if sorting is enabled for this column
        const isSortable = props.column.getColDef().sortable;

        return (
            <div
                style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
                onMouseEnter={() => setShowMenu(true)}
                onMouseLeave={() => setShowMenu(false)}
            >
                {/* Header Name - Make it clickable for sorting */}
                <span
                    style={{
                        cursor: isSortable ? "pointer" : "default",
                        userSelect: "none"
                    }}
                    onClick={isSortable ? () => {
                        const currentSort = getSort();
                        let newSort = 'asc';
                        if (currentSort === 'asc') newSort = 'desc';
                        else if (currentSort === 'desc') newSort = null;
                        onSortRequested(newSort, null);
                    } : undefined}
                >
                    {props.displayName}
                </span>

                {/* Sort indicator */}
                {isSortable && (
                    <div style={{ display: "flex", flexDirection: "column", marginRight: 2 }}>
                        <span
                            style={{
                                cursor: "pointer",
                                fontSize: 10,
                                opacity: getSort() === 'asc' ? 1 : 0.3,
                                lineHeight: "8px"
                            }}
                            onClick={() => onSortRequested('asc', null)}
                        >
                            {/* ↑ */}
                        </span>
                        <span
                            style={{
                                cursor: "pointer",
                                fontSize: 10,
                                opacity: getSort() === 'desc' ? 1 : 0.3,
                                lineHeight: "8px"
                            }}
                            onClick={() => onSortRequested('desc', null)}
                        >
                            {/* ↓ */}
                        </span>
                    </div>
                )}

                {/* Info Icon with instant tooltip */}
                <div
                    style={{ position: "relative", display: "inline-block" }}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />

                    {/* Tooltip */}
                    {showTooltip && tooltip && (
                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                // backgroundColor: "rgba(0, 0, 0, 0.8)",
                                color: "white",
                                padding: "8px 12px",
                                borderRadius: "4px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                                zIndex: 1000,
                                marginTop: "5px",
                                // pointerEvents: "none", // Add this line
                            }}
                        >
                            {tooltip}
                        </div>
                    )}
                </div>

                {/* Menu Button (☰) visible only on hover */}
                {props.enableMenu && (
                    <span
                        onClick={onMenuClick}
                        style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                            fontSize: 14,
                            opacity: showMenu ? 1 : 0,
                            transition: "opacity 0.2s ease",
                        }}
                    >
                        ☰
                    </span>
                )}
            </div>
        );
    };



  const columnWithDefs = [
    { headerName: "Destination Store ID", field: "destination_store_id" },
    { headerName: "Destination Store Name", field: "destination_store_name" },
    {
      headerName: "Destination Type",
      field: "destination_type",
      valueGetter: (params) =>
        params.data.destination_type === "darkstore" ? "DarkStore" : params.data.destination_type === "warehouse" ? "Warehouse" : "Unknown"
    },
    { headerName: "Source Name", field: "plant_name" },
    { headerName: "Source ID", field: "plant_id" },
    { headerName: "SKU Code", field: "sku_code" },
    { headerName: "SKU Name", field: "sku_name" },
    { headerName: "SKU Category", field: "sku_category" },
    {
      headerName: "Indent Cycle Date",
      field: "cycle_date",
      valueGetter: (params) =>
        params.data.cycle_date ? new Date(params.data.cycle_date).toLocaleDateString("en-GB") : "",
    },
    { headerName: "Transit Days", field: "transit_days", },
       {
      headerName: "Business Days STD",
      field: "business_days_std",

    }, {
      headerName: "Wholesale Days STD",
      field: "wholesale_days_std",

    },
    {
      headerName: "STD (Standard Deviation)", field: "std",
      headerTooltip: "Business Days STD + Wholesale Days STD",
      headerComponent: CustomHeader,
    },
    {
      headerName: "Business Day Run Rate",
      field: "business_day_run_rate",
    },
    {
      headerName: "Wholesale Day Run Rate",
      field: "wholesale_day_run_rate",
    },
    { headerName: "Cycle Time (Days)", field: "cycle_time", },
    { headerName: "Packaging Time (Days)", field: "packaging_time", },
    {
      headerName: "Protection Days", field: "protection_days",
      headerTooltip: "Transit Days + Cycle Time  + Packaging Time",
      headerComponent: CustomHeader,
      filter : true,
    },
    {
      headerName: "Service Level Factor (Z)",
      field: "service_level_factor_z",
    },
    {
      headerName: "Protection Days Stock",
      field: "protection_days_stock",
      headerTooltip: "(Sum of Protection Day's corresponding day type and it's RunRate) / 2 ",
      headerComponent: CustomHeader,
    }
    ,
    {
      headerName: "Standard Deviation Stock",
      field: "standard_deviation_stock",
      headerTooltip: "STD * Service Level Factor(Z) * sqrt(Protection Days)",
      headerComponent: CustomHeader
    },
    {
      headerName: "Safety Stock", field: "safety_stock",
      headerTooltip: "Protection Days Stock + Standard Deviation Stock",
      headerComponent: CustomHeader
    },
    {
      headerName: "ROP Buffer Stock", field: "rop_buffer_stock",
      headerTooltip: "(Transit Days + Packaging Time) * Corresponding RunRate",
      headerComponent: CustomHeader
    },
    {
      headerName: "ROP Stock",
      field: "reorder_point_stock",
      headerTooltip: "Safety Stock + ROP Buffer Stock",
      headerComponent: CustomHeader
    },
    {
      headerName: "Inserted Date",
      field: "inserted_date",
      hide: true,
      valueGetter: (params) =>
        params.data.inserted_date ? new Date(params.data.inserted_date).toLocaleDateString("en-GB") : "",
    },
  ];



  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setCurrentUploadedDate("")
    setUploadedFileData([]);
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  }

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const getSkuMasterData = async () => {
    try {
      const response = await redirectURL.post("indentation/getSafetyStockData", {})

      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const { date, destinations, skus, data } = response.data

          //   const destinationOptions = destinations.map((destination) => ({ value: destination.destination_store_id, label: `${destination.destination_store_id} - ${destination.destination_store_name}` }));
          //   destinationOptions.unshift({label : "ALL", value : ""})

          //   const skuOptions = skus.map((sku) => ({ value: sku, label: sku }));
          //   skuOptions.unshift({label : "ALL", value : ""})


          const formattedDate = date ? new Date(date).toISOString().split('T')[0] : '';

          //   setStoreOptions(destinationOptions);
          //   setStoreId(destinationOptions[0])
          //   setSkuOptions(skuOptions)
          //   setSkuCode(skuOptions[0])
          setRowData(data);
          setCurrentInvoiceDate(formattedDate);
          await getHighlightedDates();
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");

        }
      }
    }
    catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      setBasicTitle("Failed to fetch  data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getMainData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getSkuMasterData()
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const getSKUOptionsWithFilters = async () => {
    try {
      const query = {}
      query.destination_store_id = storeId?.value || ""
      query.cycle_date = currentinvoiceDate || ""

      const response = await redirectURL.post("indentation/getSKUOptionsWithFilters", query)

      if (response.status === 200) {
        const { data } = response.data
        // const destinationOptions = destinations.map((destination) => ({ value: destination.destination_store_id, 
        // label :`${destination.destination_store_id} - ${destination.destination_store_name}` }))
        // destinationOptions.unshift({label : "ALL", value : ""})

        // setStoreOptions(destinationOptions)
        // setStoreId(destinationOptions[0])
        const skuOptions = data.map(sku => ({ label: sku, value: sku }))
        skuOptions.unshift({ label: "ALL", value: "" })
        setSkuOptions(skuOptions)
        setSkuCode(skuOptions[0])
      }
    }
    catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch  data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getDestinationOptionsWithFilters = async () => {
    try {
      const query = {}
      query.cycle_date = currentinvoiceDate || ""

      const response = await redirectURL.post("indentation/getDestinationOptionsWithFilters", query)

      if (response.status === 200) {
        const { destinations } = response.data
        const destinationOptions = destinations.map((destination) => ({
          value: destination.destination_store_id,
          label: `${destination.destination_store_id} - ${destination.destination_store_name}`
        }))
        destinationOptions.unshift({ label: "ALL", value: "" })

        setStoreOptions(destinationOptions)
        setStoreId(destinationOptions[0])

      }
    }
    catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch  data");
      setBasicType("error");
      setShow(true);
    }
  }


  useEffect(() => {
    const getData = async () => {
      if (!rowData.length > 0) {
        await getMainData()
      }
    }
    getData()

  }, []);


  useEffect(() => {
    const getData = async () => {
      if (currentinvoiceDate) {
        await getSKUOptionsWithFilters()
      }
    }

    getData()

  }, [storeId]);


  useEffect(() => {
    const getData = async () => {
      if (currentinvoiceDate) {
        await getDestinationOptionsWithFilters()
      }
    }

    getData()

  }, [currentinvoiceDate]);




  const closeAlert = () => {
    const fileInput = document.getElementById("bulkUploadFile");
    if (fileInput !== null) {  // Check if the element exists
      fileInput.value = "";  // Clears the input if element exists
    }

    setUploadedFileData([]);
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setShowDeletePopup(false)
    setSliderOpen(false)
    setCurrentUploadedDate("")
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setUploadedFileData([]);
  };

  const downloadExcelTemplate = () => {
    const sampleData = [
      [
        "Destination Store Id",
        "SKU Code",
        "Sale Quantity",
        "Destination Store Name",
        // "Invoice Date"
      ],
    ];

    const ws = utils.aoa_to_sheet(sampleData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    writeFile(wb, "sample_historic_template.xlsx");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value)
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });

      const mapping = {
        "Destination Store Id": "destination_store_id",
        "Destination Store Name": "destination_store_name",
        "SKU Code": "sku_code",
        "Sale Quantity": "sale_quantity",
      };

      function toSnakeCase(str) {
        return str
          .trim()
          .replace(/\s+/g, '_')           // replace spaces with underscores
          .replace(/[A-Z]/g, letter => letter.toLowerCase()) // lowercase any capitals
          .replace(/[^a-z0-9_]/g, '')     // remove any special chars if needed
      }

      // transform
      const result = parsedData.map(item => {
        const newItem = {};
        for (const key in item) {
          if (mapping[key]) {
            // if in mapping use mapped version
            newItem[mapping[key]] = item[key];
          } else {
            // if not in mapping, convert key to snake_case
            newItem[toSnakeCase(key)] = item[key];
          }
        }
        return newItem;
      });


      console.log("Parsed Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };

  const onClickingFileSubmit = async () => {
    const params = { date: currentUploadedDate, masterData: uploadedFileData };
    try {
      const response = await redirectURL.post(
        "inventory/storeHistoricSalesData",
        params
      );

      if (response.data.status === "success") {
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Data Uploaded Successfully");
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Data Upload Failed");
      }

    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to upload data");
    }
  };




  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = { sku_code: selectedRow.sku_code };
    try {
      const response = await redirectURL.post(
        "masters/deleteSKU",
        params
      );
      if (response.data.status === "success") {
        await getSkuMasterData()
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("Order Item Deleted Successfully");
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete Order Product");
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete Order Product");
    }


  };

  const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setShowDeletePopup(false);
    setTriggerStatus(null);
    setTriggerNote("")

  };

  const getFiltersData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const params = {
      date: currentinvoiceDate,
      destination_store_id: storeId?.value || "",
      sku_code: skuCode?.value || "",
    };

    try {
      const response = await redirectURL.post(
        "indentation/getStockStatusDataWithFilters",
        params
      );
      const data = response.data.data
      setRowData(data)
      setLoadshow("show-n");
      setOverlayBlock("show-n");

    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Error Failed to get Indentation Data");
    }


  };

  const setFilters = async () => {
    setLoadshow("show-m")
    setOverlayBlock("show-m")
    await getFiltersData()
    setLoadshow("show-n")
    setOverlayBlock("show-n")
  }

  const onTriggerSubmissionFunction = async () => {
  try {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    const response = await redirectURL.post(
      "indentation/onTriggerStockStatus", 
      { trigger_date: currentDate }
    );

    const res = response?.data.pyResponse || response?.data;

    if (res?.status === "info") {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setTriggerNote(res.message || response.data.message);
      setTriggerStatus("info");
      return;
    } 
    
    if ( res?.status === "Success") {
      await getMainData();
      setOverlayBlock("show-n");
      setLoadshow("show-n");
      setShow(true);
      setBasicTitle(res.message);
      setBasicType("success");

      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Trigger Darkstore Stock Status",
        status: "Success",
        path: window.location.pathname
      };
      triggerUserAction(userData);

    } else {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicTitle(res.message);
      setBasicType(res?.status === "info" ? "info" : "error");
      
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Trigger Darkstore Stock Status",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }

  } catch (error) {
    console.error("Error triggering inventory:", error);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setShow(true);
    setBasicTitle("Something went wrong. Please try again later.");
    setBasicType("error");
    
    const userData = {
      email: localStorage.getItem("email"),
      user_code: localStorage.getItem("user_code"),
      action: "Trigger Darkstore Stock Status",
      status: "Failed",
      path: window.location.pathname
    };
    triggerUserAction(userData);
  }
};

  const checkTriggerStatusByDate = async (date) => {
    try {
      // Await the POST request

      const triggerResponse = await redirectURL.post("indentation/checkTriggerStatusByDate", { trigger_date: date });

      console.log("triggerResponse", triggerResponse)
      // Extract status safely
      const status = triggerResponse?.data?.status || "fail";
      if (status === "success") {
        setIsTrigger(status);
      } else {
        setIsTrigger(status);
      }
      return status;
    } catch (e) {
      console.error("Error checking trigger status:", e);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicTitle("Something went wrong. Please try again later.");
      setBasicType("error");
      return "fail"; // return a default/fallback value
    }
  };


  const onClickTriggerBtn = async () => {
    // Usage
    setLoadshow("show-m")
    setOverlayBlock("show-m")
    const status = await checkTriggerStatusByDate(currentDate);
    setLoadshow("show-n")
    setOverlayBlock("show-n")

    console.log("status", status)

    setIsTrigger(status)
    setSliderOpen(true)
    setOverlyBlock("show-m")
    setSliderType(2)
    setSliderTitle("Trigger Stock Status")
  };

 const setResetData = () => {
    setStoreId({label : "ALL", value : ""})
    setSkuCode({label : "ALL", value : ""})
  }

  const onTriggerSubmit = async (e) => {
    if (!currentDate) {
      setShow(true)
      setBasicTitle("Please select a date")
      setBasicType("info")
      return;
    }
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    await onTriggerSubmissionFunction()
  };

  const onClickingPopupContinueBtn = async () => {
    try {
      setTriggerStatus(null);
      setTriggerNote("")
      setLoadshow("show-m")
      setOverlayBlock("show-m")
      const response = await redirectURL.post("indentation/onTriggerStockStatusWithContinue", { trigger_date: currentDate })
      await getMainData()
      setLoadshow("show-n")
      setOverlayBlock("show-n")

      if (response.data.status === "success") {
        setOverlayBlock("show-n");
        setLoadshow("show-n");
        setShow(true)
        setBasicTitle("Stock Status Triggered Successfully");
        setBasicType("success");
     const userData = {
      email: localStorage.getItem("email"),
      user_code: localStorage.getItem("user_code"),
      action: "Not a Cycle Date - Trigger Darkstore Stock Status",
      status: "Success",
      path: window.location.pathname
      };
      triggerUserAction(userData);;
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicTitle("Something went wrong. Please try again later.");
        setBasicType("error");
      }
    }
    catch (error) {
      console.error("Error triggering inventory:", error);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicTitle("Something went wrong. Please try again later.");
      setBasicType("error");
    const userData = {
      email: localStorage.getItem("email"),
      user_code: localStorage.getItem("user_code"),
      action: "Not a Cycle Date - Trigger Darkstore Stock Status",
      status: "Failed",
      path: window.location.pathname
      };
      triggerUserAction(userData);

    }
  }

  const onChangeTriggerDate = (date) => {
    const newDate = date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    console.log({ newDate })
    const status = checkTriggerStatusByDate(newDate);
    setIsTrigger(status)
    setCurrentDate(newDate)
  }

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          >
          </SweetAlert>
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>


          {/* <div className="col-sm-12 p-0">
            <h1 className="col-sm-12" style={{ color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif" }}>Stock Status</h1>
          </div> */}

          <form className="col-sm-12 p-0 mt-2 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-10 row ">
              {/* <div className="col-sm-2 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{ fontSize: "13px", fontWeight: "400" }}
                >
                  Cycle Date:
                </label>
                <input
                  type="date"
                  id="invoiceDate"
                  value={currentinvoiceDate}
                  highlightDates={highlightedDates}
                  onChange={(e) => { setPrevDate(currentinvoiceDate); setCurrentInvoiceDate(e.target.value) }}
                  style={{ padding: "7px", borderRadius: "5px", border: "1px solid #d9d9d9", width: "100%", marginBottom: "15px", cursor: "pointer" }}
                  onClick={() => document.getElementById('invoiceDate').showPicker?.()}
                />
              </div> */}

                <div className="col-sm-2 mb-1" style={{ display: "flex", flexDirection: "column" }}>
  <label style={{ fontSize: "13px", fontWeight: "400" }}>
    Cycle Date:
  </label>
  <DatePicker
    selected={currentinvoiceDate ? new Date(currentinvoiceDate) : null}
    onChange={(date) => {
      if (date) {
        const formattedDate = date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
        setPrevDate(currentinvoiceDate);
        setCurrentInvoiceDate(formattedDate);
      } else {
        setCurrentInvoiceDate("");
      }
    }}
    dateFormat="yyyy-MM-dd"
    className="form-control"
    placeholderText="Select Cycle Date"
    highlightDates={highlightedDates}

    style={{
      width: "100%",
      fontSize: "0.9rem",
      padding: "7px 10px",
      borderRadius: "5px",
      border: "1px solid #d9d9d9",
      cursor: "pointer"
    }}
  />
</div>

              <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="storeId" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Destination Store ID:
                </label>
                <Select
                  id="storeId"
                  value={storeId}
                  onChange={(selectedOption) => { setPrevStoreId(storeId); setStoreId(selectedOption) }}
                  options={storeOptions}
                  styles={selectStyles}
                />
              </div>

              <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="storeId" style={{ fontSize: '13px', fontWeight: '400' }}>
                  SKU Code:
                </label>
                <Select
                  id="skuCode"
                  value={skuCode}
                  onChange={(skuOption) => { setPrevSkuCode(skuCode); setSkuCode(skuOption) }}
                  options={skuOptions}
                  styles={selectStyles}
                />
              </div>

              <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                <button
                  type="button"
                  onClick={(e) => { e.preventDefault(); setFilters() }}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer"
                  }}>Apply</button>
                <button
                  onClick={(e) => { e.preventDefault(); getMainData();setResetData()}}
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer"
                  }}>Reset</button>
              </div>
            </div>
            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  onClickTriggerBtn();
                }}
                type="button"
                style={{
                  backgroundColor: "#93385D",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "8px 20px",
                  border: "1px solid #d9d9d9",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  marginRight: "10px",

                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                Trigger Stock Status
              </button>

            </div>
          </form>

          <div className="col-sm-12 p-0 pl-2">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{
                  suppressHorizontalScroll: false
                }}
              // onCellClicked={onCellClicked}
              />
            </div>
          </div>

        </div>
      </div>
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>

        </div>

        {sliderType === 2 && (
          <form
            className="flex-grow-1"
            style={{ padding: "20px" }}
            onSubmit={(e) => {
              e.preventDefault();
              setSliderOpen(false);
              onTriggerSubmit();
            }}
          >
            {/* Date Field */}
            <div className="form-group mb-3">
              <label
                htmlFor="trigger-date"
                className="form-label"
                style={{
                  fontWeight: "500",
                  fontSize: "0.9rem",
                  color: "#444",
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                Date <span style={{ color: "red" }}>*</span>
              </label>
              <DatePicker
                inputId="trigger-date"
                value={currentDate}
                onChange={onChangeTriggerDate}
                placeholder="Select Date"
                className="form-control"
                isClearable
                required
                // maxDate={new Date()}
                style={{
                  width: "100%",
                  fontSize: "0.9rem",
                  padding: "8px 10px",
                  borderRadius: "5px",
                }}
              />
            </div>

            <div className="text-end mt-4">
              <button
                type="submit"
                className="btn px-4"
                style={{
                  fontSize: "0.9rem",
                  borderRadius: "5px",
                  background: "#93385D",
                  color: "#fff",
                  fontWeight: 500,
                  // cursor: isTrigger === "success" ? "pointer" : "not-allowed",
                  // opacity: isTrigger === "success" ? 1 : 0.6, // visual feedback when disabled
                }}
                // disabled={isTrigger !== "success"}
              >
                Trigger Stock Status
              </button>
            </div>

          </form>
        )}



      </div>

      {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "40%",
            left: "40%",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {`Are you sure you want to delete ${selectedRow ? selectedRow.sku_code : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
              >
                Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {triggerStatus === "info" && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)", // <-- centers the element
            zIndex: 1003,
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.2)", // optional: nice shadow
          }}
        >
          <div className="inventory-delete-popup" style={{ minWidth: "300px" }}>
            <p
              style={{
                color: "grey",
                fontSize: "18px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {triggerNote}
            </p>
            <div className="d-flex justify-content-center gap-2">
              <button
                className="btn btn-secondary"
                onClick={onClickingPopupContinueBtn}
              >
                Yes
              </button>
              <button
                className="btn btn-danger"
                onClick={onClickDeletePopupCancelBtn}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}



      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};
const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const selectStyles = {
  control: (base) => ({
    ...base,
    padding: '1px',
    borderRadius: '5px',
    border: '1px solid #d9d9d9',
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 'normal',   // <-- make the text not bold
    color: '#333',
    fontSize: "12px"         // optional: adjust color
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "13px",
    fontWeight: state.isSelected ? 'normal' : 'normal', // make options also normal if you wish
  })
}

const styles = {
  container: {
    textAlign: 'center',
    padding: "20px",
    backgroundColor: '#fff', // White background
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 10px', // Box shadow
    borderRadius: "15px"
  },
  title: {
    fontSize: "14px",
    color: "#93385d",
    // fontWeight : "600"
  },
  counterBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
    margin: '0 auto',

  },
  label: {
    fontSize: '18px',
    color: '#555',
    marginRight: '10px',
  },
  count: {
    fontSize: '25px',
    // fontWeight: '500',
    color: '#383B43',
  },
};

export default CurrentStockIndentation;
